import { service } from '../../../../helpers/http' 

export const ActionGetInstitutions = ({ dispatch }, payload) => { 
    return service({
        module: 'domainInstitution',
        action: 'getInstitutions',
        payload: payload
    })
}

export const ActionPostInstitutions = ({ dispatch }, payload) => {

    return service({
        module: 'domainInstitution',
        action: 'postInstitutions',
        payload: payload
    })
    
}

export const ActionPutInstitutions = ({ dispatch }, payload) => {

    return service({
        module: 'domainInstitution',
        action: 'putInstitutions',
        payload: payload
    })
    
}

export const ActionDeleteInstitutions = ({ dispatch }, payload) => {

    return service({
        module: 'domainInstitution',
        action: 'deleteInstitutions',
        payload: payload
    })
    
}
